document.addEventListener("DOMContentLoaded",function(){
  document.querySelectorAll(".homare-tabs").forEach(tabsContainer=>{
    const tabs=tabsContainer.querySelectorAll(".homare-tabs__tab");
    const contents=tabsContainer.querySelectorAll(".homare-tabs__content");
    tabs.forEach(tab=>{
      tab.addEventListener("click",function(){
        const target=this.dataset.tab;
        tabs.forEach(t=>t.classList.remove("active"));
        this.classList.add("active");
        contents.forEach(c=>c.classList.remove("active"));
        const targetContent=tabsContainer.querySelector(`#${target}`);
        if(targetContent)targetContent.classList.add("active");
      });
    });
    if(tabs.length>0&&contents.length>0){
      tabs[0].classList.add("active");
      contents[0].classList.add("active");
    }
  });
});
